<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MultiSelect from '@/components/form/MultiSelect.vue'
import { CHANNELS } from '@/lib/contactPoints.js'

/** Which channels a kind of e-mail or phone is offered for (D-238): "Work" for both, "Fax" for a phone only. */
defineProps({ modelValue: { type: Array, default: () => [] }, row: { type: Object, default: null }, context: { type: Object, default: null }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
const { t } = useI18n()
const options = computed(() => CHANNELS.map((c) => ({ value: c, label: t(`dictionaries.channels.${c}`) })))
</script>

<template>
  <MultiSelect :model-value="modelValue || []" :options="options" :disabled="disabled" @update:model-value="(v) => emit('update:modelValue', v)" />
</template>
